import React, { Fragment } from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import {
  CustomTermsWrapper,
  CustomTermsHeader,
  CustomTermsContent,
  CustomTermsLink,
} from "./styles/custom-terms-styles";

const CustomTerms = ({ customTerms, customTermsUrl }) => (
  <CustomTermsWrapper>
    {customTerms && (
      <Fragment>
        <CustomTermsHeader id="custom-terms-header">
          Employer’s specific Terms of Business
        </CustomTermsHeader>
        <CustomTermsContent>
          {parse(customTerms)}
          {customTermsUrl && (
            <CustomTermsLink
              data-test-id="custom-terms-url"
              href={customTermsUrl}
              target="_blank"
              rel="noopener noreferrer"
              title="View Full Terms"
            >
              View full terms
            </CustomTermsLink>
          )}
        </CustomTermsContent>
      </Fragment>
    )}
  </CustomTermsWrapper>
);

CustomTerms.propTypes = {
  customTerms: PropTypes.string,
  customTermsUrl: PropTypes.string,
};

CustomTerms.defaultProps = {
  customTerms: PropTypes.isNull,
  customTermsUrl: PropTypes.isNull,
};

export default React.memo(CustomTerms);
